import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getPlan } from "@/features/auth/services/plan.service";
import type { Plan } from "@/features/auth/types/plan.type";

type UsePlanQueryProps = {
  enabled: boolean
  organizationId: string | null
  accessToken: string | null
  onGetPlanSuccess: (plan: Plan) => void
  onGetPlanError: () => void
};

export const usePlanQuery = ({
  enabled, organizationId, accessToken, onGetPlanSuccess, onGetPlanError,
}: UsePlanQueryProps) => {
  const query = useQuery<Plan>({
    queryKey: ["plan", organizationId],
    queryFn: () => getPlan(organizationId ?? "", accessToken ?? ""),
    enabled: enabled && !!accessToken && !!organizationId,
  });

  useEffect(() => {
    if (query.isSuccess && query.data) {
      onGetPlanSuccess(query.data);
    }
  }, [query.isSuccess, query.data, onGetPlanSuccess]);

  useEffect(() => {
    if (query.isError) {
      onGetPlanError();
    }
  }, [query.isError, onGetPlanError]);

  return query;
};
